import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const userService = {
    async getUserInfo(id){
        try{
            return await $api.get(`${API_URL}/user/` + id)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async editUserInfo(id, data){
        try{
            return await $api.put(`${API_URL}/user/` + id, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
};